<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card elevation="0">
          <v-row no-gutters>
            <v-col cols="12">
              <template>
                <v-data-table :headers="tableHeader" :items="tableItems" :items-per-page="tableItems.length"
                  :max-height="height" :hide-default-footer="true" @click:row="(item) => $emit('rowClick', item)" dense
                  class="elevation-0 state-tabel tt table">
                  <template v-slot:no-data>
                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() { },
  props: {
    tableHeader: {
      type: Array,
      require: true,
    },
    tableItems: {
      type: Array,
      require: false,
    },
    height: {
      type: String,
      require: false,
    },
  },
};
</script>
<style lang="scss">
.state-tabel {
  overflow: hidden;
}

.table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
<style scoped>
>>>.v-data-table-header {
  background: var(--dark-color) !important;
}

>>>.state-tabel thead th:first-child {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

>>>.state-tabel thead th:last-child {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

>>>.v-data-table-header tr th span {
  color: white !important;
}

>>>.state-tabel {
  border: 1px solid var(--light-color) !important;
  border-radius: 8px !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
